<template>
    <div class="print-header" style="display: flex;">
        <div>
            <img :src="img" style="height: 120px;">
        </div>
        <div class="text-center" style="width: 650px;">
            <h4 class="text-center font-m" style="font-weight: bold;">{{company.Name}}</h4>
            <h4 class="text-center" style="font-weight: bold;">{{company.LatinName}}</h4>
            <div style="font-size: 13px;">
                អាសយដ្ឋាន៖ ផ្ទះលេខ {{company.Home}} ផ្លូវ {{company.Street}} ភូមិ {{company.Village}} សង្កាត់ {{company.Commune}} ខណ្ឌ {{company.District}} រាជធានី{{company.Capital}}
            </div>
            <div style="font-size: 13px;">
                Tel: {{company.Phone}} <span>Email</span>: {{company.Email}}
                <br>
                លេខអត្តសញ្ញាណកម្មសារពើពន្ធ​អតប (VAT): {{company.TinHead}}-{{company.VatTin}}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                company: {},
                img: './img/no-logo.png'
            }
        },
        created(){
            this.getCompany();
        },
        methods: {
            getCompany() {
                let req = {
                    Id: this.$store.state.company.Id
                };
                this.$api().post("company/find", req).then(res => {
                    this.company = res.data.Json.Company;
                    if(!this.$isEmpty(this.company.Logo)){
                        this.img = this.$base() + 'image/logo/' + this.company.Logo;
                    }
                });
            }
        }
    }
</script>